export default {"src":"/uk/_next/static/media/bullet-checkmark.170310ee.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};